import Axios from "../../../Config/API";
import {
    IContatoTelefone,
    IDeletarContatoTelefone,
} from "../../../../Interfaces/Geral/Contatos/ContatoTelefone/ContatoTelefoneInterface";
import Service from "../../../Service";

export async function ListarContatosTelefoneService(IDContato: number) {
    return Service(
        Axios.get<Array<IContatoTelefone>>(
            `/home/contatotelefone/listarcontatostelefone?IDContato=${IDContato}`
        )
    );
}

export async function ListarContatosTelefoneUAUService(DS_CHAVE_ERP: string) {
    return Service(
        Axios.get<Array<IContatoTelefone>>(
            `/home/contatotelefone/listarcontatostelefoneuau?ID_CHAVE_ERP_CONTA=${DS_CHAVE_ERP}`
        )
    );
}

export async function AtualizarContatoTelefoneService(
    requestBody: IContatoTelefone
) {
    return Service(
        Axios.put(`/home/contatotelefone/atualizarcontatotelefone`, requestBody)
    );
}

export async function CadastrarContatoTelefoneService(
    requestBody: IContatoTelefone
) {
    return Service(
        Axios.post(
            `/home/contatotelefone/cadastrarcontatotelefone`,
            requestBody
        )
    );
}

export const DeletarContatoTelefoneService = (
    requestBody: IDeletarContatoTelefone
) => {
    let url = `/home/contatotelefone/deletarcontatotelefone`;
    let jaTemQuery = false;

    // forma para tratar 'undefined's da query string
    if (requestBody.IDContatoTelefone) {
        url = url.concat(
            `${jaTemQuery ? "&" : "?"}IDContatoTelefone=${
                requestBody.IDContatoTelefone
            }`
        );
        jaTemQuery = true;
    }
    if (requestBody.ID_CHAVE_ERP) {
        url = url.concat(
            `${jaTemQuery ? "&" : "?"}ID_CHAVE_ERP=${requestBody.ID_CHAVE_ERP}`
        );
        jaTemQuery = true;
    }
    if (requestBody.COD_DDD) {
        url = url.concat(
            `${jaTemQuery ? "&" : "?"}COD_DDD=${requestBody.COD_DDD}`
        );
        jaTemQuery = true;
    }
    if (requestBody.NR_TELEFONE) {
        url = url.concat(
            `${jaTemQuery ? "&" : "?"}NR_TELEFONE=${requestBody.NR_TELEFONE}`
        );
        jaTemQuery = true;
    }

    return Service(Axios.delete(url));
};
